  
  


  
  <!-- 彈窗 選擇附加品項-->
  <ng-template #Modal let-data let-ref="dialogRef">
  


    <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
      <nb-card-header>
        選擇附加品項群組

        <div class="row mx-0 mt-3">
          <input  class="col"  [(ngModel)]="query.searchKey" name="searchKey" type="text" nbInput fullWidth 
            shape="rectangle" placeholder="輸入附加品項群組標題">           
          <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
            <i class="fas fa-search"></i>
          </button>            
        </div>

        <div class="d-flex mx-0 mt-2 justify-content-between">
          <button class="col-auto mr-auto btn" nbButton (click)="onSelectAll()">
            {{status.isSelectAll ? '取消全部' : '選擇全部'}}  
          </button>  
          <nb-select class="col-auto pr-0"   style="width:180px" 
              [(ngModel)]="selectORG_Store_ID"  (selectedChange)="onQuery()">
              <nb-option *ngFor="let e of storeSelectList" [value]="e.value" > {{ e.content }}</nb-option>
          </nb-select>
          <nb-select class="col-auto pr-0" style="width:100px"  
            [(ngModel)]="status.showType"  (selectedChange)="onShowType()">
            <nb-option *ngFor="let e of list.showType" [value]="e.value" > {{ e.name }}</nb-option>
          </nb-select>        
        </div>


      </nb-card-header>
      <nb-card-body>
       
        
         
      
        <div class="">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>選取</th>
                <th>附加品項群組標題</th>
                <th>內容</th>
                <th>選項類型</th>
                <th>必選</th>
                <th>建立門市</th>
              </tr>
            </thead>
            <tbody *ngIf="showList">
              <tr *ngFor="let item of showList; let j = index">
                <td *ngIf="item.isSelect" (click)="onSelect(false,item)">
                 <button class="btn btn-info py-0 px-1 checkbtn"> <i class="fa fa-check"></i>       </button>          
                </td>
                <td *ngIf="!item.isSelect" (click)="onSelect(true,item)">
                  <button class="btn btn-info py-0 px-1  checkbtn " >    </button>                
                </td>
                <td style="vertical-align: middle;">{{item.GroupName}}</td>
                <td style="vertical-align: middle;">{{item.Content}}</td>
                <td style="vertical-align: middle;">{{item.AttachItemKindName}}</td>
                <td style="vertical-align: middle;">{{item.IsRequiredName}}</td>
                <td style="vertical-align: middle;">{{item.CreateStoreName}}</td>
              </tr>

            </tbody>
          </table>
        </div>


        


        
      </nb-card-body>
      <nb-card-footer>
        <button nbButton  class="btn btn-info" (click)="onSave()">確定</button>
        <button nbButton (click)=" ref.close()">關閉</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>